<template>
  <p>
    Após o pagamento da entrada, o restante da sua negociação poderá ser acompanhado diretamente no
    site, aplicativo, ou em qualquer loja da <strong>Riachuelo</strong>.
  </p>
</template>
